const t = {
  name: "Contract",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 3C21 1.34315 19.6569 0 18 0H6C4.34315 0 3 1.34315 3 3V21C3 22.6569 4.34315 24 6 24H14.4142L21 17.4142V3ZM5 21V3C5 2.44772 5.44772 2 6 2H18C18.5523 2 19 2.44772 19 3V15H15C13.3431 15 12 16.3431 12 18V22H6C5.44771 22 5 21.5523 5 21ZM14 21.5858V18C14 17.4477 14.4477 17 15 17H18.5858L14 21.5858Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Contract
};
